import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WarningIcon = createIcon({
    viewBox: '0 0 100 100',
    path: (
        <>
            <Path
                d='M50 98C76.51 98 98 76.51 98 50C98 23.49 76.51 2 50 2C23.49 2 2 23.49 2 50C2 76.51 23.49 98 50 98ZM50 100C22.386 100 0 77.614 0 50C0 22.386 22.386 0 50 0C77.614 0 100 22.386 100 50C100 77.614 77.614 100 50 100Z'
                fill='currentColor'
            />
            <Path
                d='M48.455 40.534C48.455 39.764 49.147 39.14 50 39.14C50.853 39.14 51.545 39.764 51.545 40.534V53.524C51.545 54.294 50.853 54.918 50 54.918C49.147 54.918 48.455 54.294 48.455 53.524V40.534ZM50 61.378C48.888 61.378 47.986 60.564 47.986 59.561C47.986 58.557 48.888 57.743 50 57.743C51.112 57.743 52.014 58.557 52.014 59.561C52.014 60.564 51.112 61.378 50 61.378ZM22.135 69.466C21.274 69.466 20.727 68.634 21.141 67.953L49.006 21.998C49.436 21.289 50.564 21.289 50.994 21.998L78.859 67.953C79.273 68.634 78.726 69.466 77.865 69.466H22.135ZM24.047 67.421H75.953L50 24.62L24.047 67.421Z'
                fill='currentColor'
            />
        </>
    ),
})

WarningIcon.displayName = 'WarningIcon'
